<template>

    <template v-if="type === 'list'">
        <template v-if="! loading">
            <h4 class="text-center" @click="showEmbed" v-if="bookmarked == 0">
              <span class="iconify" :data-icon="bookmarked > 0 ? 'clarity:heart-solid' : 'clarity:heart-line'" data-height="30px" data-inline="false"></span>
            </h4>
            <h4 class="text-center" @click="bookmarkHandler" v-else>
              <span class="iconify" :data-icon="bookmarked > 0 ? 'clarity:heart-solid' : 'clarity:heart-line'" data-height="30px" data-inline="false"></span>
            </h4>
        </template>
        <div class="spinner-grow mx-auto bg-warning" role="status" v-else>
            <span class="visually-hidden">Loading...</span>
        </div>
    </template>
    <template v-else-if="type === 'detail'">
        <template v-if="! loading">
           <span @click="showEmbed" v-if="bookmarked == 0">
                <span class="iconify text-danger ms-5 cursor-pointer" data-height="40px" :data-icon="bookmarked > 0 ? 'clarity:heart-solid' : 'clarity:heart-line'" data-inline="false"></span>
           </span>
            <span @click="bookmarkHandler" v-else>
                <span class="iconify text-danger ms-5 cursor-pointer" data-height="40px" :data-icon="bookmarked > 0 ? 'clarity:heart-solid' : 'clarity:heart-line'" data-inline="false"></span>
           </span>
        </template>
        <span class="spinner-grow ms-5 bg-warning" role="status" v-else>
            <span class="visually-hidden">Loading...</span>
        </span>
    </template>
    <template v-else-if="type === 'viral'">
        <template v-if="! loading">
             <span @click="showEmbed" v-if="bookmarked == 0">
                <span class="iconify text-danger cursor-pointer viral-bookmark" data-height="30px" :data-icon="bookmarked > 0 ? 'clarity:heart-solid' : 'clarity:heart-line'" data-inline="false"></span>
            </span>
            <span @click="bookmarkHandler" v-else>
                <span class="iconify text-danger cursor-pointer viral-bookmark" data-height="30px" :data-icon="bookmarked > 0 ? 'clarity:heart-solid' : 'clarity:heart-line'" data-inline="false"></span>
            </span>
        </template>
        <span class="spinner-grow bg-warning" role="status" v-else>
            <span class="visually-hidden">Loading...</span>
        </span>
    </template>
    <template v-else-if="type === 'saved'">
        <template v-if="! loading">
            <h4 class="trend-status" @click="showEmbed" v-if="bookmarked == 0">
                <span class="iconify" :data-icon="bookmarked > 0 ? 'clarity:heart-solid' : 'clarity:heart-line'" data-height="30px" data-inline="false"></span>
            </h4>
            <h4 class="trend-status" @click="bookmarkHandler" v-else>
                <span class="iconify" :data-icon="bookmarked > 0 ? 'clarity:heart-solid' : 'clarity:heart-line'" data-height="30px" data-inline="false"></span>
            </h4>
        </template>
        <div class="spinner-grow bg-warning" role="status" style="position: absolute;right: 20px; top: 10px;" v-else>
            <span class="visually-hidden">Loading...</span>
        </div>
    </template>
    <template v-else-if="type === 'guest'">
      <h4 class="text-center" data-bs-toggle="modal" data-bs-target="#authModal">
        <span class="iconify" data-icon="clarity:heart-line" data-height="30px" data-inline="false"></span>
      </h4>
    </template>
    <teleport to="body">
    <div class="modal" tabindex="-1" :id="modalId">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header" v-if="productTitle">
                    <h5 class="modal-title text-capitalize">{{ productTitle }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="notes = ''"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Notes (Optional)</label>
                            <textarea v-model="notes" class="form-control" cols="30" rows="10"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn s-sm btn-secondary btn-danger" data-bs-dismiss="modal" @click="notes = ''">Close</button>
                    <button type="button" class="btn btn s-sm btn-secondary btn-orange" data-bs-dismiss="modal" @click="bookmarkHandler">Save</button>
                </div>
            </div>
        </div>
    </div>
    </teleport>
</template>

<script>
export default {
    name: 'Bookmark',
    props: {
        productTitle: { default: '' },
        type: { default: 'list' },
        isBookmark: { required: true },
        id: {required: true},
        isWinning: {required: true},
    },
    computed: {
       modalId() {
           return 'mb_bookmark_'+this.id;
       }
    },
    data() {
        return {
            loading: false,
            bookmarked: this.isBookmark,
            notes : '',
        }
    },
    methods: {
        bookmarkHandler() {
             this.loading = true;
            axios.post(__st.routes.product_bookmark, {
                product_id: this.id,
                is_winning: this.isWinning,
                notes: this.notes,
            }).then((d) => {
                this.bookmarked = d.data.bookmarked;
                toaster(d.data.message, (this.bookmarked == 1 ? "success" : "info"), "bottom-left");
            }).catch(({response}) => {
                if(response.status == 422) {
                    toaster(response.data.message, "error")
                }
                this.loading = false;
                this.notes = '';
            }).finally(() => {
                   this.loading = false;
                   this.notes = '';
            })
        },

        showEmbed() {

            if(this.type == 'guest')
            {
                return;
            }

            const myModal = new bootstrap.Modal(document.getElementById(this.modalId))
            myModal.show();
        },
    }
}
</script>


<style scoped>
    svg.viral-bookmark  {
        vertical-align: text-bottom !important;
    }
</style>
